/* Shared top-layer modal behaviour for product images, sizing and FAQs. */
(function () {
  'use strict';
  if (window.ProductDialog) return;
  var opened = new Set();

  function mount(dialog, callbacks) {
    callbacks = callbacks || {};
    var controller = new AbortController();
    var opener = null;
    var active = false;

    function release(restoreFocus) {
      if (!active) return;
      active = false;
      opened.delete(dialog);
      document.documentElement.classList.toggle('product-dialog-open', opened.size > 0);
      dialog.classList.remove('active');
      var restored = callbacks.close && callbacks.close();
      opener = restored || opener;
      if (restoreFocus && opener && opener.isConnected && opener.getClientRects().length) {
        opener.focus({ preventScroll: true });
      }
      opener = null;
    }

    function close(restoreFocus) {
      if (dialog.open) dialog.close();
      release(restoreFocus !== false);
    }

    function open(trigger) {
      if (dialog.open || !dialog.isConnected) return;
      document.dispatchEvent(new CustomEvent('theme:close-navigation'));
      opener = trigger || document.activeElement;
      dialog.showModal();
      active = true;
      opened.add(dialog);
      document.documentElement.classList.add('product-dialog-open');
      dialog.classList.add('active');
      if (callbacks.open) callbacks.open();
      dialog.querySelector('[data-product-dialog-close]')?.focus({ preventScroll: true });
    }

    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !dialog.open) return;
      var controls = Array.from(dialog.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return element.tabIndex >= 0 && !element.closest('[inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
      });
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }, { signal: controller.signal });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    }, { signal: controller.signal });
    dialog.addEventListener('close', function () {
      // A queued close event from a rapid close/reopen must not release the new modal.
      if (!dialog.open) release(true);
    }, { signal: controller.signal });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-product-dialog-close]')) close();
    }, { signal: controller.signal });

    return { open: open, close: close, destroy: function () { close(false); controller.abort(); } };
  }
  window.ProductDialog = { mount: mount };
})();
